/* =============================================================================
   PRO360 BOOT — lógica del landing pro360 extraída de layout/theme.liquid.
   Solo se carga cuando template.suffix == 'pro360' (ver snippets/pro360-inject.liquid).

   3 módulos:
     1) savingsBadge     — reescribe el badge "Oferta" con el monto ahorrado.
     2) easysellVibrate  — tagea el sticky de EasySell para animación CSS.
     3) easysellThankyou — guarda el pedido para la página /pages/gracias.
   ============================================================================= */
(function () {
  'use strict';

  // ---------- 1) SAVINGS BADGE ----------
  // Cambia "Oferta" → "Oferta, ahorra S/. XX" en .price__badge-sale (Dawn).
  var savingsBadge = (function () {
    var patching = false;

    function update() {
      if (patching) return true;
      var badge = document.querySelector('.price__badge-sale');
      if (!badge) return false;
      var regEl = document.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular s');
      var saleEl = document.querySelector('.price__sale .price-item--sale');
      if (!regEl || !saleEl) return false;
      // Extrae el primer número decimal de un string tipo "S/. 139.00".
      // Preserva 139 en vez de leer ".139" como 0.139 (bug del parser previo).
      var num = function (t) {
        var m = String(t).match(/\d+(?:\.\d+)?/);
        return m ? parseFloat(m[0]) : 0;
      };
      var saved = num(regEl.textContent) - num(saleEl.textContent);
      if (saved <= 0) return true;
      var newText = 'Oferta, ahorra S/. ' + Math.round(saved);
      if (badge.textContent === newText) return true;
      patching = true;
      badge.textContent = newText;
      setTimeout(function () { patching = false; }, 30);
      return true;
    }

    return function init() {
      update();
      var target = document.querySelector('[id^="price-"]');
      if (window.MutationObserver && target) {
        new MutationObserver(update).observe(target, { childList: true, subtree: true });
      }
      // Retry corto por si Dawn tarda en renderizar el precio (10x200ms = 2s).
      var tries = 0;
      var iv = setInterval(function () {
        if (update() || ++tries > 10) clearInterval(iv);
      }, 200);
    };
  })();

  // ---------- 2) EASYSELL VIBRATE ----------
  // Tagea el sticky de EasySell con .pro360-easysell-vibrate (fallback:
  // el CSS ya cubre las clases estándar, esto protege ante variantes futuras).
  var easysellVibrate = (function () {
    var SELECTORS = [
      '.es-popup-button-sticky',
      '[class*="es-popup-button-sticky"]',
      '[class*="es-sticky"]',
      '[id*="es-sticky"]',
      '[id*="easysell-sticky"]',
      '[id*="cod-sticky"]'
    ].join(',');

    function tag() {
      try {
        document.querySelectorAll(SELECTORS).forEach(function (el) {
          el.classList.add('pro360-easysell-vibrate');
        });
      } catch (e) {}
    }

    return function init() {
      tag();
      // MutationObserver perpetuo cubre inyecciones tardías de EasySell.
      if (window.MutationObserver) {
        new MutationObserver(tag).observe(document.body, { childList: true, subtree: true });
      }
    };
  })();

  // ---------- 3) EASYSELL THANK-YOU ----------
  // EasySell hace `await window.es_hook_before_redirect(order)` justo antes de
  // redirigir (en todos sus modos). Guardamos un resumen mínimo del pedido para
  // que /pages/gracias lo muestre. Sin teléfono ni dirección exacta.
  // Clave compartida con assets/gracias.js. Ver CONTEXT.md → "EasySell — flujo post-compra".
  var easysellThankyou = (function () {
    var KEY = 'pz_last_order';

    // line_items[].handle llega como URL completa → nos quedamos con el slug.
    function slug(h) {
      var m = String(h || '').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : String(h || '');
    }

    function slim(o) {
      var ship = (o.shipping_lines || [])[0] || {};
      var addr = o.shipping_address || {};
      return {
        v: 1,
        saved_at: Date.now(),
        number: String(o.order_number || o.number || ''),
        first_name: (o.customer && o.customer.first_name) || addr.first_name || '',
        currency: o.currency || 'PEN',
        subtotal: Number(o.subtotal_price || 0),   // ya incluye el descuento
        discount: Number(o.current_total_discounts || 0), // ej. pack x2 = "QUANTITY DISCOUNT"
        total: Number(o.total_price || 0),
        shipping_title: ship.title || '',
        shipping_price: Number(ship.price || 0),
        province_code: addr.province_code || '',
        province: addr.province || '',
        city: addr.city || '',
        status_url: o.order_status_url || '',
        items: (o.line_items || []).map(function (li) {
          return {
            title: li.title || li.name || '',
            variant_title: li.variant_title || '',
            quantity: Number(li.quantity || 1),
            price: Number(li.price || 0),
            handle: slug(li.handle)
          };
        })
      };
    }

    return function init() {
      var prev = window.es_hook_before_redirect;
      window.es_hook_before_redirect = async function (order) {
        try {
          var data = JSON.stringify(slim(order || {}));
          try { sessionStorage.setItem(KEY, data); } catch (e) {}
          try { localStorage.setItem(KEY, data); } catch (e) {}
        } catch (e) {}
        if (typeof prev === 'function') return prev(order);
      };
    };
  })();

  // ---------- BOOT ----------
  function boot() { savingsBadge(); easysellVibrate(); easysellThankyou(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
